import { render } from "./OtherOptionsTable.vue?vue&type=template&id=06aad7a0"
import script from "./OtherOptionsTable.vue?vue&type=script&lang=js"
export * from "./OtherOptionsTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__